<template>
  <div>
    <event-head></event-head>
    <!-- 商户列表卡片 -->
    <normal-card title="用户管理" class="mt-5">
      <el-table :data="merchantList" style="width: 100%" :header-cell-style="{
        color: '#fff',
        fontSize: '14px',
        height: '40px',
        backgroundColor: '#1a1a1a00'
      }" :cell-style="{ backgroundColor: '#1a1a1a00', color: '#fff' }">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="userName" label="昵称" align="center"></el-table-column>
        <el-table-column prop="userLogo" label="头像" align="center">
          <template slot-scope="scope"><el-image :src="scope.row.userLogo" :preview-src-list="[scope.row.userLogo]"
              fit="cover" style="width: 40px; height: 40px; border-radius: 4px; cursor: pointer"></el-image></template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>
        <el-table-column prop="userSex" label="性别" align="center"></el-table-column>
        <el-table-column prop="userAge" label="年龄" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户id" align="center"></el-table-column>
        <el-table-column prop="totalAmount" label="交易金额" align="center">
          <template slot-scope="scope">¥{{ formatAmount(scope.row.totalAmount) }}</template>
        </el-table-column>
        <!-- <el-table-column prop="version" label="系统版本" align="center"></el-table-column>
        <el-table-column label="佣金比例" align="center" width="120">
          <template slot-scope="scope">
            <span style="margin-right: 8px">{{ scope.row.commissionRate }}%</span>
            <el-button type="text" style="color: #409EFF" @click="showAdjustDialog(scope.row)">调整</el-button>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已入驻' ? 'success' : 'warning'" effect="dark">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="拉黑操作" align="center" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" :disabled="scope.row.status === '已入驻'"
              @click="handleApprove(scope.row)">同意入驻</el-button> -->
            <el-button type="text" style="color: #ff4d4f" @click="handleDelete(scope.row)">拉黑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </normal-card>

    <!-- 调整佣金弹窗 -->
    <el-dialog title="调整佣金比例" :visible.sync="adjustDialogVisible" width="30%" custom-class="dark-dialog">
      <el-form label-width="120px">
        <el-form-item label="佣金比例">
          <el-input-number v-model="currentCommission" :min="1" :max="10" controls-position="right"
            placeholder="请选择"></el-input-number>%
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="adjustDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdjust">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
import normalCard from '@/common/components/normal/NormalCard';

export default {
  components: {
    EventHead,
    normalCard
  },
  data() {
    return {
      merchantList: [
        {
          id: 1,
          matchName: 'XX球队',
          createTime: '2025-05-23 13:34:21',
          userName: '微信用户',
          userLogo: "https://x-ai.oss-cn-hangzhou.aliyuncs.com/25.3.18/zhongxin.png",
          userAge: 30,
          userSex: "男",
          userId: "MJ-5yvksbhvh",
          phone: '13812345678',
          totalAmount: '123456.00',
          version: '基础版',
          commissionRate: 3,
          status: '审核中'
        },
        {
          id: 2,
          matchName: 'ZA球队',
          createTime: '2025-05-23 15:34:22',
          userName: '李四',
          userLogo: "https://x-ai.oss-cn-hangzhou.aliyuncs.com/25.3.18/zhongxin.png",
          userSex: "男",
          userAge: 30,
          phone: '13812345678',
          totalAmount: '123456.00',
          version: '会员版',
          userId: "MJ-5yvksbhvh",
          commissionRate: 2,
          status: '已入驻'
        }
      ],
      adjustDialogVisible: false,
      currentCommission: 0,
      selectedMerchant: null
    }
  },
  methods: {
    // 格式化金额显示
    formatAmount(value) {
      return parseFloat(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    // 显示调整弹窗
    showAdjustDialog(row) {
      this.selectedMerchant = row
      this.currentCommission = row.commissionRate
      this.adjustDialogVisible = true
    },

    // 确认调整佣金
    confirmAdjust() {
      this.$confirm('确定要调整佣金比例吗？', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'dark-message'
      }).then(() => {
        this.selectedMerchant.commissionRate = this.currentCommission
        this.adjustDialogVisible = false
        this.$message.success('佣金比例调整成功')
      })
    },

    // 同意入驻
    handleApprove(row) {
      this.$confirm('确定通过该商户的入驻申请吗？', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'dark-message'
      }).then(() => {
        row.status = '已入驻'
        this.$message.success('操作成功')
      })
    },

    // 删除商户
    handleDelete() {
      this.$confirm('暂不支持拉黑该用户!', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'dark-message'
      }).then(() => {
        // this.merchantList = this.merchantList.filter(item => item.id !== row.id)
        // this.$message.success('')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dark-dialog {
  background: #1a1a1a00;
  border: 1px solid #333;

  .el-dialog__title {
    color: #fff;
  }

  .el-input-number {
    .el-input__inner {
      background: #33333300;
      color: #fff;
      border-color: #555;
    }

    .el-input-number__decrease,
    .el-input-number__increase {
      background: #444;
      color: #fff;
      border-color: #555;
    }
  }
}

.el-table {
  background: transparent;

  &::before {
    background-color: #33333300;
  }

  th.el-table__cell {
    background: #1a1a1a00 !important;
  }

  td.el-table__cell {
    background: #1a1a1a !important;
    border-bottom: 1px solid #33333300;
  }
}

.el-tag {
  border: none;
  padding: 4px 10px;
}
</style>